module.exports = __webpack_public_path__ + "static/img/clock.0993cc52.png";